<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        <ng-container [formGroup]="owner">
          <ng-template #default></ng-template>
          <div class="row">
            <div class="col-md-12">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="esgProfil">
                <div class="row">
                  <div class="col-md-12">
                    <span class="pr-input-label ng-star-inserted"
                      >Quel critère ESG souhaitez vous privilégier dans votre
                      investissement ?
                    </span>
                  </div>
                  <div class="col-md-12">
                    <div class="checkbox">
                      <pr-checkbox-group
                        formControlName="investments"
                        [template]="default"
                        [options]="investmentsOptions"
                      >
                      </pr-checkbox-group>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
